module.exports = __webpack_public_path__ + "static/onesdata-a0151328540262ed4e40a1d6a98b8863.jpg";